var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"dropdown-content"}},[(_vm.active)?_c('div',{staticClass:"origin-top-right absolute right-0 mt-2 w-48 bg-white rounded-lg py-2"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }